import React, { useState, VFC } from "react"
import { Link } from "gatsby"
import { useEffect } from "react"
import { useLocation } from "@reach/router"

type Props = {
  items: {
    text: string
    path: string
  }[]
  toggleMenu: () => void
}

const DrawerMenu: VFC<Props> = ({ toggleMenu, items }) => {
  const [currentPath, setCurrentPath] = useState("")
  const location = useLocation()
  useEffect(() => {
    setCurrentPath(location.pathname)
  }, [])

  return (
    <div className="text-center">
      <div className="mt-20 space-y-8 text-lg text-brown font-kiwiMaru">
        {items.map(item => {
          return (
            <div key={item.text}>
              <Link
                to={item.path}
                className={
                  item.path === currentPath ? "text-Brown font-bold" : undefined
                }
                onClick={toggleMenu}
              >
                {item.text}
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default DrawerMenu
